var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 9.125C19.125 11.4032 17.2782 13.25 15 13.25C12.7218 13.25 10.875 11.4032 10.875 9.125C10.875 6.84683 12.7218 5 15 5C17.2782 5 19.125 6.84683 19.125 9.125Z",
    stroke: "#D0D0D0",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 27V22.2685C5.375 20.7876 6.22267 19.4337 7.60963 18.9146C9.48056 18.2144 12.635 17.375 15 17.375C17.4149 17.375 20.0945 18.2502 22.2071 18.9587C23.6852 19.4545 24.625 20.8626 24.625 22.4216V27",
    stroke: "#D0D0D0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.d18bbb329f2a37eeb3b6418f46af5fca.svg";
export { ForwardRef as ReactComponent };